const MSG91_SCRIPT_ID = "msg91-otp-provider";

const widgetId = process.env.REACT_APP_MSG91_WIDGET_ID;
const tokenAuth = process.env.REACT_APP_MSG91_WIDGET_TOKEN;

function msg91Error(message) {
  return new Error(message);
}

function logProviderError(stage, raw) {
  try {
    console.error(`[MSG91:${stage}]`, typeof raw === "object" ? JSON.stringify(raw) : raw);
  } catch (_e) {
    console.error(`[MSG91:${stage}]`, raw);
  }
}

function getWindowMethod(name) {
  const method = window[name];
  if (typeof method !== "function") {
    throw msg91Error("SMS verification is unavailable. Please refresh and try again.");
  }
  return method;
}

export function loadMsg91Widget() {
  if (!widgetId || !tokenAuth) {
    return Promise.reject(msg91Error("SMS verification is not configured yet."));
  }

  if (window.__quickDoorMsg91Ready) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const initialize = () => {
      try {
        if (window.__quickDoorMsg91Ready) {
          resolve();
          return;
        }
        if (typeof window.initSendOTP !== "function") {
          throw msg91Error("SMS verification could not be started. Please try again.");
        }
        window.initSendOTP({
          widgetId,
          tokenAuth,
          exposeMethods: true,
          success: (data) => logProviderError("init-success", data),
          failure: (err) => logProviderError("init-failure", err),
        });
        window.__quickDoorMsg91Ready = true;
        resolve();
      } catch (error) {
        reject(error);
      }
    };

    if (window.initSendOTP) {
      initialize();
      return;
    }

    const existing = document.getElementById(MSG91_SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", initialize, { once: true });
      existing.addEventListener(
        "error",
        () => reject(msg91Error("SMS verification service could not be loaded.")),
        { once: true },
      );
      return;
    }

    const script = document.createElement("script");
    script.id = MSG91_SCRIPT_ID;
    script.src = "https://verify.msg91.com/otp-provider.js";
    script.async = true;
    script.onload = initialize;
    script.onerror = () => reject(msg91Error("SMS verification service could not be loaded."));
    document.head.appendChild(script);
  });
}

export function sendMsg91Otp(phone) {
  return new Promise((resolve, reject) => {
    try {
      const sendOtp = getWindowMethod("sendOtp");
      sendOtp(
        `91${phone}`,
        resolve,
        (err) => {
          logProviderError("sendOtp", err);
          reject(msg91Error("Could not send SMS. Please try again."));
        },
      );
    } catch (error) {
      reject(error);
    }
  });
}

export function resendMsg91Sms() {
  return new Promise((resolve, reject) => {
    try {
      const retryOtp = getWindowMethod("retryOtp");
      retryOtp(
        "11",
        resolve,
        (err) => {
          logProviderError("retryOtp", err);
          reject(msg91Error("Could not resend SMS. Please try again."));
        },
      );
    } catch (error) {
      reject(error);
    }
  });
}

export function verifyMsg91Otp(otp) {
  return new Promise((resolve, reject) => {
    try {
      const verifyOtp = getWindowMethod("verifyOtp");
      verifyOtp(
        otp,
        resolve,
        (err) => {
          logProviderError("verifyOtp", err);
          reject(msg91Error("The SMS code is invalid or expired."));
        },
      );
    } catch (error) {
      reject(error);
    }
  });
}

export function msg91AccessToken(response) {
  if (typeof response === "string") {
    return response;
  }
  if (!response || typeof response !== "object") {
    return "";
  }
  return (
    response["access-token"] ||
    response.accessToken ||
    response.access_token ||
    response.token ||
    response.message ||
    ""
  );
}